import { action, observable } from 'mobx';
import { LogEvents } from '~/services/fullstory/log-events';
import { FullstoryService } from '~/services/fullstory/fullstory.service';
import { INetworkStore } from '~/types/dependency.types';

interface INewtorkStoreProps {
    logger: FullstoryService;
}
export class NetworkStore implements INetworkStore {
    private logger: FullstoryService;
    @observable requests: Map<string, number> = new Map();
    @observable isOnline: boolean;

    constructor({ logger }: INewtorkStoreProps) {
        this.logger = logger;
        this.initializeState();
    }

    @action.bound
    private initializeState() {
        this.isOnline = true;
    }

    @action.bound
    startNetwork(label: string) {
        const requestCount: number = this.requests.get(label) || 0;

        this.requests.set(label, requestCount + 1);
    }

    @action.bound
    endNetwork(label: string) {
        const requestCount: number = this.requests.get(label) || 0;

        if (requestCount < 1) {
            return;
        }

        this.requests.set(label, requestCount - 1);
    }

    @action.bound
    setIsOnline(isOnline: boolean) {
        this.logger.warn(LogEvents.ConnectionStableStatusChange(isOnline));

        this.isOnline = isOnline;
    }

    getByLabel(label: string): number {
        const requestCount: number = this.requests.get(label) || 0;

        return requestCount;
    }

    isLoading(label: string): boolean {
        const requestCount: number = this.requests.get(label) || 0;

        return requestCount > 0;
    }
}
